<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-7",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 7,
      nextPage: '/questionnaire/section1/8',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Prepare_for_pregnancy.png'),
        mainTitle: 'Do you know PCOS(polycystic ovary syndrome)?',
        btn: [
          [
            {
              text: 'Yes',
              operation: 'add product FM-INSI-101'
            },{
              text: 'No',
              operation: 'add product FM-PREVI-101'
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
